

/**
 * 获取点的中心
 * @param {*} pointList 
 * @returns 
 */
export const getCenter = (pointList = []) => {
    if (!pointList || pointList.length == 0) {
        return null;
    }
    let sum = pointList.reduce((pre, cur) => {
        return { x: pre.x + cur.x, y: pre.y + cur.y }
    }, { x: 0, y: 0 })
    let center = {
        x: sum.x / pointList.length,
        y: sum.y / pointList.length
    }
    return center;
}

/**
 * 
 * @param {*} params 
 */
export function getHeading(pointList) {
    if (!pointList || pointList.length == 0) {
        return null;
    }
    let len1 = Math.pow(Math.pow(pointList[0].x - pointList[1].x, 2) + Math.pow(pointList[0].y - pointList[1].y, 2), 0.5);
    let len2 = Math.pow(Math.pow(pointList[2].x - pointList[1].x, 2) + Math.pow(pointList[2].y - pointList[1].y, 2), 0.5);
    if (len1 > len2) {
        return getHeading2(pointList[0], pointList[1]);
    } else {
        return getHeading2(pointList[1], pointList[2]);
    }
}

export function getHeading2(start, end) {
    return Math.atan2(end.y - start.y, end.x - start.x);
}